import script from "./MostaContextMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MostaContextMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MostaContextMenu.vue?vue&type=style&index=0&id=33fe701c&lang=scss"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QSelect});
